<div class="page-padding">

  <div style="margin-left: 39%;" *ngIf="DigtalFormOverview == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>
  <div class="panel" *ngIf="DigtalFormOverview != null">
    <div class="panel__header">
      <span class="panel__header__title">
        Form Details
      </span>
    </div>

    <div class="panel__content flex flex--align-center">

      <div class="column-container flex-grow" style="justify-content: initial;">
        <div class="column-container__column" style="width: 50%;">
          <div class="text-block">
            <span class="text-block__label">
              Form Name
            </span>
            <span class="text-block__important">
              {{form.FormName}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Form Category
            </span>
            <span class="text-block__important">
              {{form.FormCategoeryName}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
             Linked Customers
            </span>
            <span class="text-block__important">
              {{form.customerListName}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
             Equipment
            </span>
            <span class="text-block__important">
              {{form.Serial}}
            </span>
          </div>
        </div>
        <!-- <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Linked Family
            </span>
            <span class="text-block__important">
              {{form.familyListName}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Linked Model
            </span>
            <span class="text-block__important">
              {{form.modelListName}}
            </span>
          </div>
        </div> -->


        
      </div>
    </div>
  </div>

  <div class="input-container addsapce" *ngIf="DigtalFormOverview != null">
   
     
    <span class="label"><b>Form Status</b></span>
    <select id="satus" placeholder="Select Status" [(ngModel)]="form.FormStatusID"
        (change)="UpdateStatus()" ngDefaultControl >
        <option [value]="status.ID" *ngFor="let status of statusTypes">
          {{status.Status}}
        </option>
    </select>


</div>
  <div *ngIf="DigtalFormOverview != null">
    
      <a class="button button--primary" (click)="ViewAll()">
        <span class="button__text">View All Categories</span></a>
   
      <a class="button button--primary" style="float: right;" (click)="UpdateAllQuestions()" [class.loading]="update">
        <span class="button__text">Update Changes</span></a>
  </div>
  <div style="margin-bottom: 2%;">


    

    <ng-container *ngFor="let fc of formQCategories">



      <mat-expansion-panel class="parametersPanel" [expanded]="true">
        <mat-expansion-panel-header style="background: #E0E0E0;">
          <div class="panel__header">


            <span class="panel__header__title" style="font-size: larger;">
              <b>{{fc.QCategoryName}}</b>
            </span>
          </div>
        </mat-expansion-panel-header>
        <div>
          <ng-container *ngFor="let fs of formQSections">
            <mat-expansion-panel class="parametersPanel" *ngIf="fc.QuestionCatId == fs.ParentCatId">
              <mat-expansion-panel-header style="background: #E8E8E8;">
                <div class="panel__header" style="display: flex; flex-direction: column;">
                  <span class="panel__header__title" style="font-size: medium;">
                    {{fs.QCategoryName}}

                  </span>
                  <span style="font-size: small;"> {{fs.QuestionCount}} Questions</span>
                </div>
              </mat-expansion-panel-header>

              <div>
                <mat-accordion>
                  <ng-container *ngFor="let fq of formQuestions">
                    <mat-expansion-panel (opened)="GetSelectedQuestion(fq.QuestionId)" (closed)="panelOpenState = false"  (afterExpand)="selectedId = fq.QuestionId"
                      class="parametersPanel" *ngIf="fq.QuestionCatId == fs.QuestionCatId" >
                      <mat-expansion-panel-header style="background: #F0F0F0 ;">
                        <div class="panel__header" style="display: flex; flex-direction: row; justify-content: space-between; flex: 1; margin-right: 4%;">
                          <div style="display: flex;flex-direction: column; width:90% ;cursor: pointer;">
                            <span class="panel__header__title">
                              {{fq.QTitle}}
                           </span>
                           <span style="font-size: small;">  <b>Inspected By:</b> {{fq.InspectorName}}</span>
                          </div>
                          
                          <div style="width:10%">
                            <i  *ngIf="fq.UnableToComplete==false && fq.inspectorId!=null" class="material-icons button__icon" style="font-size: 28px;margin-right: 20px; color:limegreen;vertical-align: middle;">check_circle_outline</i>
                            <i  *ngIf="fq.UnableToComplete==true" class="material-icons button__icon" style="font-size: 28px;margin-right: 20px;color: red;vertical-align: middle;">highlight_off</i>
                            <i  *ngIf="fq.UnableToComplete==false && fq.inspectorId==null" class="material-icons button__icon" style="font-size: 28px;margin-right: 20px;vertical-align: middle;">trip_origin</i>


                              <i  *ngIf="fq.UploadImages==null" class="material-icons button__icon" style="font-size: 28px; margin-right: 20px;vertical-align: middle;">camera_alt</i>
                              <i  *ngIf="fq.UploadImages!=null" class="material-icons button__icon" style="font-size: 28px; margin-right: 20px;color: royalblue;vertical-align: middle;">camera_alt</i>
                           
                           
                              <i  *ngIf="fq.QuestionComment!=null" class="material-icons button__icon" style="font-size: 28px; color: royalblue;vertical-align: middle;">assignment</i>
                              <i  *ngIf="fq.QuestionComment==null" class="material-icons button__icon" style="font-size: 28px;vertical-align: middle; ">assignment</i>
                          </div>
                        </div>
                      </mat-expansion-panel-header>
                      <div style="display: flex;">
                        <div style="padding: 1%; width: 50%;">
                          <div style="display: flex;flex-direction: column;">
                            <span class="panel__header__title"><b>Instructions</b></span>
                            <span class="panel__header__title">{{fq.QDescription}}</span>
                          </div>

<div style="display: flex; flex-direction: row;">
  <div *ngIf="fq.HasQuestionImage==true"
  style="display:flex;flex-direction:row;font-size: 14px;">
  <img id="img_{{fq.QuestionId}}" style='display:block; width: 250px;'
    [src]="getImage(fq.QuestionImage)" />
</div>
<div *ngIf="fq.HasQuestionImage==false"
  style="display:flex;flex-direction:row;font-size: 14px;">
  <img id="img_{{fq.QuestionId}}" style='display:block; width: 250px;'
    src="/Content/Images/NO-IMAGE_Sample.jpg" />
</div>
<div *ngIf="fq.EditedQuestionImage == '' ||  fq.EditedQuestionImage == null"
    style="display:flex;flex-direction:row;font-size: 14px;margin-left: 2%">
    <img id="Editimg_{{fq.QuestionId}}" style='display:none; width: 250px;' />
  </div>
  <div *ngIf="fq.EditedQuestionImage != '' && fq.EditedQuestionImage != null"
    style="display:flex;flex-direction:row;font-size: 14px;     margin-left: 1%;">
    <img id="Editimg_{{fq.QuestionId}}" style='display:block; width: 250px;'
      [src]="getImage(fq.EditedQuestionImage)" />
  </div>
</div>
                          
                          <ng-container *ngIf="fq.ImageEdit">
                            <div>
                              <a class="button button--primary" (click)="EditImage(fq.QuestionId,fq.QuestionImage, fq)">
                                <span class="button__text">Edit Image</span>
                                <i class="material-icons button__icon">brush</i></a>
                            </div>
                            
                          </ng-container>


                        </div>

                        <div style="padding: 1%; width: 50%;">
                          <div style="display: flex; flex-direction: column;">
                            <div>
                              <span class="panel__header__title"><b> Question: {{fq.QTitle}}</b></span>
                            </div>


                            <div style="display: flex; flex-direction: row; justify-content: space-between;">
                              <ng-container *ngIf="fq.ModelAnswers.length > 1">

                                <ng-container *ngIf="fq.QuestionTypeId != 3">

                                  <div
                                    style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">


                                    <mat-radio-group style="display: flex;flex-direction: column;"
                                      >
                                      <mat-radio-button *ngFor="let answers of fq.ModelAnswers" [value]="answers"  (change)="SelectAnswer($event,answers.AnswerId,fq)"
                                        [checked]="answers.select">

                                        <span>{{answers.Answer}}</span></mat-radio-button>

                                    </mat-radio-group>


                                  </div>
                                </ng-container>
                                <ng-container *ngIf="fq.QuestionTypeId == 3">
                                  <div
                                    style="display:flex;flex-direction:column;font-size: 14px;margin-left: 2%; margin-top: 1%;">
                                    <ng-container *ngFor="let answers of fq.ModelAnswers">
                                      <mat-checkbox id="check_{{answers.AnswerId}}"  [(ngModel)]="answers.select">
                                        <span>{{answers.Answer}}</span>
                                      </mat-checkbox>
                                    </ng-container>
                                  </div>
                                </ng-container>

                              </ng-container>

                              <ng-container *ngIf="fq.ModelAnswers.length == 1">

                                <ng-container *ngIf="fq.QuestionTypeId == 4">
                                  <textarea style="width: 50%;" id="freetext_{{fq.QuestionId}}" rows="4" maxlength="256" [(ngModel)]="fq.ModelAnswers[0].Answer" (focusout)="UpdateFreetextOrNumber($event,fq)"
                                    placeholder="Answer"></textarea>
                                </ng-container>

                                <ng-container *ngIf="fq.QuestionTypeId == 5">
                                  <input type="number" style="width: 50%;" id="numerical_{{fq.QuestionId}}" [(ngModel)]="fq.ModelAnswers[0].Answer"  (focusout)="UpdateFreetextOrNumber($event,fq)"
                                    placeholder="Answer">

                                </ng-container>

                              </ng-container>

                              <ng-container *ngIf="fq.ModelAnswers.length == 0">
                                <ng-container *ngIf="fq.QuestionTypeId == 6">
                                  Comming Soon!
                                </ng-container>
                              </ng-container>


                            </div>
                            <div
                              style="display: flex; flex-direction: row; justify-content: space-between;margin-top: 3%;">
                              <textarea style="width: 60%;" id="questionComment_{{fq.QuestionId}}" rows="4" [(ngModel)]="fq.QuestionComment"
                                maxlength="256" placeholder="Comment or reason for cannot complete"></textarea>
                              <mat-checkbox  [(ngModel)]="fq.UnableToComplete"> Unable to Complete</mat-checkbox>
                            </div>

                          </div>
                          <ng-container *ngIf="fq.AllowImages">
                            <hr>
                            <!-- <div style="flex: 1 0 67%">
                              <div>

                                <div style="padding-left: 8px; flex: 1; display: flex;">
                                  <div id="btnAddImage_{{fq.QuestionId}}" class="sc-icon"
                                    (click)="OpenImagePop(fq.QuestionId)">
                                    <i class="material-icons">add</i>
                                    <span style="padding-left: 8px;">Add Image</span>
                                  </div>
                                  <input type="file" id="hdnAddImage_{{fq.QuestionId}}"
                                    name="hdnAddImage_{{fq.QuestionId}}" style="visibility: hidden;"
                                    (change)="onImageFileUploaded_Question(fq.QuestionId)"
                                    accept=".jpg,.jpeg,.gif,.png,.bmp" />
                                </div>
                              </div>
                              <div style="display: flex; flex-wrap: wrap" id="imgContainer_{{fq.QuestionId}}">

                              </div>

                            </div> -->
                            


                            <!--new code-->

                            <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap">
                              <input hidden type='file' (change)="onSelectPhoto($event, fq)" #uploadImage>
      
                              <ng-container>
                                  <div class="add-new-schematic" (click)="uploadImage.click()" style="float: left; margin-right: 1%;"
                                      matTooltip="Click to upload a image">
                                      <i class="material-icons add-new-schematic__icon">add_box</i>
                                      <div class="add-new-schematic__text">Add Image</div>
                                  </div>
      
                                  <ng-container *ngIf="fq.UploadImages!=null">
                                    <ng-container *ngFor="let img of fq.UploadImages">
                                          <img [src]="getImage(img)" class="selection__image"
                                              style="width: 100px;" />
                                     
                                      <mat-icon  style="margin-left: 14px; cursor: pointer;"
                                          (click)="deleteimage(img,fq)">delete</mat-icon>
                                  </ng-container>
                                  </ng-container>
                                  
      
                                  <div id="ulSchematics" class="selection-container">
      
                                  </div>
                              </ng-container>
                          </div>
                            <!--end new code-->
                          </ng-container>



                        </div>

                        
                      </div>



                    </mat-expansion-panel>
                  </ng-container>
                </mat-accordion>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </div>

      </mat-expansion-panel>

    </ng-container>
  </div>

</div>